import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {Link, useLocation} from 'react-router-dom';
import {MenuItem} from '@components';
import {MenuItem2} from '@components';

import {PfImage} from '@profabric/react-components';
import styled from 'styled-components';
import {SidebarSearch} from '@app/components/sidebar-search/SidebarSearch';
import i18n from '@app/utils/i18n';

export interface IMenuItem {
  name: string;
  path?: string;
  icon?: string;
  enable?: boolean;
  children?: Array<IMenuItem>;
}

export let MENU: IMenuItem[] = [];

const StyledBrandImage = styled(PfImage)`
  float: left;
  line-height: 0.8;
  margin: -1px 8px 0 6px;
  opacity: 0.8;
  --pf-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23) !important;
`;

const StyledUserImage = styled(PfImage)`
  --pf-box-shadow: 0 3px 6px #00000029, 0 3px 6px #0000003b !important;
`;

const MenuSidebar = (props: any) => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const sidebarSkin = useSelector((state: any) => state.ui.sidebarSkin);
  const menuItemFlat = useSelector((state: any) => state.ui.menuItemFlat);
  const menuChildIndent = useSelector((state: any) => state.ui.menuChildIndent);
  const location = useLocation();
  // MENU.push(props.mymenu);
  // MENU = MENU.concat(props.mymenu);
  console.log(props.mymenu);
  MENU = props.mymenu
    ? props.mymenu
    : [
        {
          name: 'เมนูการเดินทาง',
          icon: 'fa-car',
          children: [
            {
              name: 'การวางแผน',
              path: '/trip-make',
              enable: true
            },
            {
              name: 'การอนุมัติ',
              path: '/trip-approve',
              enable: true
            },
            {
              name: 'การเดินทาง | รถของฉัน',
              path: '/trip-me',
              enable: true
            },
            {
              name: 'ค่าใช้จ่ายกลุ่มต้นทุน',
              path: '/trip-costcenter',
              enable: true
            },
            {
              name: 'เบอร์คนขับรถ',
              path: '/trip-driver',
              enable: true
            },
            {
              name: 'รายงาน',
              path: '/trip-report',
              enable: true
            },
            {
              name: 'ปฏิทินรถยืม',
              path: '/trip-calendar',
              enable: true
            },
            {
              name: 'เมนู CR',
              path: '/trip-cr',
              enable: true
            }
          ]
        }
      ];

  return (
    <aside className={`main-sidebar elevation-4 ${sidebarSkin}`}>
      <Link to="/" className="brand-link">
        <StyledBrandImage
          src="/img/logo.png"
          alt="aA service"
          width={33}
          height={33}
          rounded
        />
        <span className="brand-text font-weight-light">aA service</span>
      </Link>
      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <StyledUserImage
              src={user.PersonImageInternet}
              fallbackSrc="/img/default-profile.png"
              alt="User"
              width={34}
              height={34}
              rounded
            />
          </div>
          <div className="info">
            <Link to="/profile" className="d-block">
              {user.Account}
            </Link>
          </div>
        </div>

        <div className="form-inline">
          <SidebarSearch MENU={MENU}/>
          {/* <SidebarSearch/> */}
        </div>

        <nav className="mt-2" style={{overflowY: 'hidden'}}>
          <ul
            className={`nav nav-pills nav-sidebar flex-column${
              menuItemFlat ? ' nav-flat' : ''
            }${menuChildIndent ? ' nav-child-indent' : ''}`}
            role="menu"
          >
            {MENU.map((menuItem: IMenuItem, index: Number) => (
              <MenuItem
                key={menuItem.name + menuItem.path}
                menuItem={menuItem}
                group={index}
                level={0}
              />
            ))}

            {/* {MENU.map((menuItem, index) => (
              <MenuItem2
                index={index}
                name={menuItem.name}
                icon={menuItem.icon}
                path={menuItem.path}
                children={menuItem.children}
                key={menuItem.name + menuItem.path}
                currentPath={location}
                level={0}
              />
            ))} */}

            {/* <li className="nav-item">
              <a
                href={`http://cdsexp.doubleapaper.com/login.aspx?user_id=${user.ID_EMP}&signed_request=oFtc%2BBWWuMK5OwMTMKyqCw%3D%3D&service_id=5009&timestamp=1645243181`}
                target={'_blank'}
                className="nav-link"
              >
                <i className="far fa-circle nav-icon text-danger" />
                <p>{'ระบบเดิม'}</p>
              </a>
            </li> */}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default MenuSidebar;
